<template>
  <div>
    <Topheader></Topheader>
      <!--xinx条-->
      <div v-show="infoBodyShow" class="info-top-body">
        <div class="w1100">
          <div class="top2-body">
            <div class="top2-name">建立良好交流关系，请{{userInfo.name}}完成：</div>
            <div class="t-sx" v-show="!userInfo.yesOrNoSet"></div>
            <div class="top2-list" v-show="!userInfo.yesOrNoSet" @click="$router.push('/infoEditInfo')">添加个人设定</div>
            <div class="t-sx" v-show="userInfo.gr_img_num < 4"></div>
            <div class="top2-list" v-show="userInfo.gr_img_num < 4" @click="$router.push('/userInfo')">个人主页发布作品</div>
            <div class="t-sx" v-show="userInfo.linkers < 1"></div>
            <div class="top2-list" v-show="userInfo.linkers < 1" @click="$router.push('/recommend')">连接linker</div>
            <div class="t-sx" v-show="!userInfo.tel"></div>
            <div class="top2-list" v-show="!userInfo.tel" @click="$router.push('/bindTel')">验证手机统一账户</div>
          </div>
        </div>
      </div>

    <div class="homeLR" :style="'top:'+(infoBodyShow?'60px':'10px')">
      <div class="left">
        <div class="home-t">
          Home
        </div>
        <div class="name head_body" >
          <img class="headerImg" @click="$router.push('/userInfo')" :src="userInfo.head_url?userInfo.head_url: ''" alt="">
          <div @click="$router.push('/userInfo')">
            <div class="names user-name" >{{userInfo.name}}</div>
            <div class="user-tip">发布创作、随笔记录等</div>
          </div>

        </div>

        <div class="name head_body" @click="$router.push('/cloud')">
          <img class="headerImg" src="../../static/icon/yuntai.png" alt="">
          <div>
            <div  class="names user-name">云台</div>
            <div class="user-tip">媒体服务创建工作间</div>
          </div>

        </div>

        <div class="tit">CANAPE</div>
        <div class="name head_body">
          <img src="../../static/icon/dtsw.png" alt="">
          <router-link to="/dynamic?isLinkers=false" :style="isLinkers == 'true' ? '':'font-weight: bold;'" class="names">动态事务</router-link>

        </div>
        <div class="name cursor head_body" @click="$router.push('/debut')">
          <img src="../../static/icon/Debut.png" alt="">
          <router-link to="/debut" class="names">Debut</router-link>
        </div>
        <div class="name cursor head_body">
          <img src="../../static/icon/lkzy.png" alt="">
          <router-link to="/dynamic?isLinkers=true" class="names" :style="isLinkers == 'true' ? 'font-weight: bold;':''">和linker重要关系</router-link>
        </div>

        <div class="tit">受欢迎的Linking</div>
        <div class="name cursor head_body">
          <img src="../../static/icon/ds.png" alt="">
          <router-link to="/pointTime" class="names">Highlight大赏</router-link>
        </div>

      </div>
      <div class="right">
        <div class="homeRCont">
          <!-- 1 -->
          <div class="welcome">

            <div class="welcome-title">
              <div class="icon">
                <img src="../../static/icon/yaoqing.png" alt="">
              </div>
              <div class="welcomeName">
                欢迎邀请您的伙伴加入Woshuoxia
              </div>
            </div>

            <div class="welcome-spk">

              请在个人主页上发布您的创作或者记录、随拍等，
              只有你发布了更多的作品才可以被推荐， 表现个人
              特点和个性，才会吸引对您感兴趣的人物， link 你
              和互动关系，今天开心喔！

            </div>
          </div>

          <!--可能需要start-->

          <div class="kn-body" @click="selectLinker()">
              <div class="kn-spk1">您可能会需要找到ta们？</div>
              <img class="kn-icon" src="../../static/icon/tw.png" alt="">
              <div class="kn-blue">@ Linker提您关心的问题…</div>
              <div class="kn-spk2">从这里开始找到1V1的真实答案</div>
          </div>
          <!--可能需要end-->

          <div class="kn-b-tex">
            路上有您的陪伴支持着我 Woshuoxia   2019<br/>
            <a @click="toBeian()" style="color: #989898;" href="https://beian.miit.gov.cn/#/Integrated/index" _target="_blank">备案信息：蜀ICP备2020025859号-1</a>

          </div>

        </div>
      </div>
    </div>
    <div class="w1100">
      <div class="home" :style="'position: relative;margin-top: '+(infoBodyShow?'70px':'20px')">
        <div class="center">
          <div v-if="isLinkers != 'true'" class="postMsg">
            <div class="tabs">
              <div class="word" :class="homePhotoUpNum==1?'active':''" @click="homePhotoUP(1)">
                <img v-if="homePhotoUpNum==1" src="../../static/icon/update-someon.png" alt="">
                <img v-else src="../../static/icon/update-someoff.png" alt="">
                Update Some
              </div>
              <div class="word" :class="homePhotoUpNum==2?'active':''" @click="homePhotoUP(2)">
                <img v-if="homePhotoUpNum==2" src="../../static/icon/addphotoon.png" alt="">
                <img v-else src="../../static/icon/addphotooff.png" alt="">
                Add Photos
              </div>
            </div>
            <div class="fromWord">
              <textarea
                @input="textareaF"
                placeholder="你有什么事？#您的Slogan#"
                cols="30"
                rows="10"
                v-model="content"
              ></textarea>
            </div>
            <div class="post">
              
              <div class="picture">
                <span class="add" v-show="upPictrue" @click="upImg()">
                  <img v-if="upImgStates" src="../../static/icon/add-photo-on.png" alt="">
                  <img v-else src="../../static/icon/add-photo.png" alt="">
                </span>
                <span v-show="upPictrue" @click="upImg()">上传照片最多12张</span>
              </div>
              
              <div class="off-on-body" v-show="upPictrue">
                <span>是否公开</span>
                <img class="off-on-img" @click="onIsGongkai()" v-if="is_gongkai == 1" src="../../static/icon/on.png" alt="">
                <img class="off-on-img" @click="onIsGongkai()" v-else src="../../static/icon/off.png" alt="">
              </div>
              
              
              <div class="button" :class="textareaL>0?'active':''"   @click="dynamicPost()">Post</div>
              <div class="upPicture" v-show="upImgStates">
                <div class="pictureNum">
                  <!-- 已上传： -->
                  <div class="num">{{imgs_id.length}} 张</div>
                  <div class="close" @click="close()">
                    <img src="../../static/icon/offup.png" alt />
                  </div>
                </div>
                <el-upload
                  ref="my-upload"
                  :action="common.uploadUrl()"
                  multiple
                  :class="{hide:hideUpload}"
                  list-type="picture-card"
                  :before-upload="beforeAvatarUpload"
                  :on-preview="handlePictureCardPreview"
                  :on-success="handleAvatarSuccess"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  :limit="12"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" size="tiny" class="Img">
                  <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
              </div>
            </div>
          </div>
          <div v-else class="linkerMsg">
              <div class="linkerText">你和linker互动的越多了解才会更多，交际才会越广泛！</div>
              <div><span class="linkerNum">{{jiaoliuNum}}</span><span class="numUnit">条</span></div>
          </div>

          <!-- 今日活跃 start -->
          <div class="today-body" v-show="!userInfo.huoyue && (yesterdayUser.fyUser || yesterdayUser.tUser || yesterdayUser.pUser || yesterdayUser.cUser)">
              <div class="today-top">
                <div class="today-time">{{yesterdayUser.day}}日-最活跃的linker</div>
                <div class="today-close" @click="closHuoyue()"><img src="../../static/icon/offup.png" alt=""></div>
              </div>

              <div class="today-content">
                  <div class="td-user-list"  v-if="yesterdayUser.fyUser" @click="onClickDayUser(yesterdayUser.fyUser.user_id)">
                    <img :src="yesterdayUser.fyUser.head_url" alt="">
                    <div class="td-name">@{{yesterdayUser.fyUser.user_name}}</div>
                    <div class="td-spk">{{yesterdayUser.fyUser.num}} 发言 · {{yesterdayUser.fyUser.zyly}}</div>
                  </div>
                <div class="td-user-list" v-if="yesterdayUser.tUser" @click="onClickDayUser(yesterdayUser.tUser.user_id)">
                  <img :src="yesterdayUser.tUser.head_url" alt="">
                  <div class="td-name">@{{yesterdayUser.tUser.user_name}}</div>
                  <div class="td-spk">{{yesterdayUser.tUser.num}} 动态 · {{yesterdayUser.tUser.zyly}}</div>
                </div>
                <div class="td-user-list" v-if="yesterdayUser.pUser" @click="onClickDayUser(yesterdayUser.pUser.user_id)">
                  <img :src="yesterdayUser.pUser.head_url" alt="">
                  <div class="td-name">@{{yesterdayUser.pUser.user_name}}</div>
                  <div class="td-spk">{{yesterdayUser.pUser.num}} 播放Debut · {{yesterdayUser.pUser.zyly}}</div>
                </div>
                <div class="td-user-list" v-if="yesterdayUser.cUser" @click="onClickDayUser(yesterdayUser.cUser.user_id)">
                  <img :src="yesterdayUser.cUser.head_url" alt="">
                  <div class="td-name">@{{yesterdayUser.cUser.user_name}}</div>
                  <div class="td-spk">{{yesterdayUser.cUser.num}} 查看发言 · {{yesterdayUser.cUser.zyly}}</div>
                </div>
              </div>

          </div>
          <!-- 今日活跃 end -->

          <!--查看方式 start-->
          <div class="show-type-body">
            <div class="s-t-xt"></div>
            <div class="s-t-right">
              <span class="s-t-s1">查看方式：</span>
              <span class="s-t-s2" @click="selectShow()">{{userInfo.show_huoyue_type == 1?'全部' : '你的'}}</span>

              <div v-if="stsShow" class="slelect-sts-body">
                <p @click="changeSts()" :class="userInfo.show_huoyue_type == 1 ? 'sts-a':''">全部</p>
                <p @click="changeSts()" :class="userInfo.show_huoyue_type == 2 ? 'sts-a':''">你的</p>
              </div>
            </div>
          </div>
          <!--查看方式 end-->

          <!--为你推荐 start-->
          <div class="you-tj-body">
              <div class="you-tage">为您推荐</div>

              <div class="you-tj-content">
                  <div class="y-tj-left">
                    <el-image class="y-tj-img1" :src="rmdInfo.dList[1].img_url" fit="cover"></el-image>
                    <el-image class="y-tj-img2" :src="rmdInfo.dList[0].img_url" fit="cover" ></el-image>
                  </div>
                <div class="y-tj-right name" v-if="rmdInfo.user">
                  <router-link
                          :to="{name:'recommend',params:{ids:rmdInfo.ids}}"
                  >{{rmdInfo.user.userName}}</router-link>

                  <span v-if="rmdInfo.user.others">and</span>
                  <router-link
                          v-if="rmdInfo.user.others"
                          :to="{name:'recommend',params:{ids:rmdInfo.ids}}"
                          class="sixPeople"
                  >{{rmdInfo.user.others}}</router-link>

                  <span>ta们会不会是有料的伙伴呢？感兴趣就“Link”吧，相信你会遇见开心！</span>
                </div>
                <div class="y-tj-right name" v-else>
                  <span>现在还没有可以为您推荐的连接者，您可以在个人主页发布4张以上的图片，展示给您的伙伴看！</span>
                </div>
              </div>
          </div>
          <!--为你推荐 end-->

          <!--回答您的问题 start-->
          <div class="huida-body" v-show="!userInfo.wt_model_show && answerMyInfo.userName">
            <div class="huida-left">
              <span class="huida-name">{{answerMyInfo.userName}}</span>
              <span class="huida-num">回答您的{{answerMyInfo.num}}个问题</span>
            </div>
            <div class="huida-right">
                <div class="huida-cha" style="cursor: pointer;" @click="$router.push('/wendaList')">去查看</div>
                <img class="huida-close" @click="closeHuida()" src="../../static/icon/offup.png" alt="">
            </div>
          </div>
          <!--回答您的问题 end-->



          <!-- 事物内容 start -->
          <div class="news" v-for="(vo,key) in list" :key="vo.id">
            <div v-if="vo.type == 1 || vo.type == 2 || vo.type == 3">
              <div class="follow-page" v-if="vo.type == 3">You follow {{vo.user_name}}`s page</div>
              <div class="topHead" @click="toUserInfo(vo.user_id)">
                <img :src="vo.head_url" alt="">
                <div class="left">
                  <router-link to class="name">{{vo.user_name}}</router-link>
                  <div class="time">{{vo.create_time}}</div>
                </div>
              </div>
              <div class="picture picture22" style="position: relative;" v-if="vo.type == 3 || vo.imgList.length<100">
                <el-image
                  style="width: 100%; max-height: 544px;"
                  :src="vo.imgList[0]"
                  alt=""
                  :preview-src-list="imgList[key]"
                ></el-image>
                <el-image
                        style="cursor: pointer;position: absolute;right: 10px;top: 10px;background: rgba(0,0,0,0.1);width: 35px;height: 35px;"
                        src="../../static/icon/imgM.png"
                        alt=""
                        v-if="vo.imgList.length > 1"
                        :preview-src-list="imgList[key]"
                ></el-image>
              </div>
              <!-- banner end -->
              <div class="message" v-if="vo.highlight_num > 0 || vo.content || vo.leave_num>0">
                <div class="num" v-if="vo.highlight_num > 0">{{vo.highlight_num}}次Highlight</div>
                <div
                  class="word"
                  :ref="'wordH'+key"
                  v-if="vo.content"
                  :class="vo.height>=96  && !vo.is_zank? 'wordHight':''"
                ><div v-html="vo.content"></div>

                <div class="zan" v-if="vo.height >=96 && !vo.is_zank" @click="zanF(key)">{{vo.is_zank ? '收起':'...展开'}}</div>
                </div>
                <div class="speakNum mt12">
                  <span
                    class="toAll"
                    v-if="vo.leave_num > 0"
                    @click="toSeeinterflow(key)"
                  >全部{{vo.leave_num}}条发言</span>
                  <span v-if="vo.linker_type == 1" class="yellowR"><img src="../../static/icon/wfy.png" alt=""></span>
                  <span v-else-if="vo.linker_type == 2" class="yellowR"><img src="../../static/icon/wzs.png" alt=""></span>
                  <span v-else-if="vo.linker_type == 3" class="yellowR"><img src="../../static/icon/yjz.png" alt=""></span>
                  <span class="noSpeak">{{vo.linker_spk}}</span>
                </div>
                <div class="mt12" v-if="vo.leaveList.length>0">
                  <div class="name" v-for="(leave,index) in vo.leaveList" :key="index">
                    <span class="nameWord">{{leave.user_name}}</span>
                    {{leave.content}}
                  </div>
                </div>
              </div>
              <!-- 图片end -->
              <div class="Interflow">
                <div v-show="!vo.is_focus">
                  <div v-if="vo.is_highlight" @click="onHighlight(key)" class="icon">
                    <img src="../../static/icon/highlighton.png" alt="">
                  </div>
                  <div v-else class="icon" @click="onHighlight(key)">
                    <img src="../../static/icon/highlight.png" alt="">
                  </div>
                </div>
                <div class="word">
                  <input
                    type="text"
                    @focus="focusInput(key)"
                    @blur="hideInput(key)"
                    v-model="vo.interflowContent"
                    placeholder="Interflow…"
                  >
                </div>
                <div
                  class="button"
                  :class="vo.interflowContent ? 'active' : ''"
                  v-show="vo.is_focus == true"
                  @click="subInterflow(key)"
                >Post</div>
              </div>
            </div>

            <!--招牌玩家 start-->
            <div v-else-if="vo.type == 4">
              <div class="news1-top-body">
                <div class="zbq-bt-dj-body">
                  <el-image class="n1-top-img" :src="vo.signboard.img_url" fit="cover"></el-image>
                  <div class="zbq-bt-dj"></div>
                </div>
                <div class="pdlr10">

                  <div class="n1-top-name-body" @click="toUserInfo(vo.user_id)" style="cursor: pointer;">
                    <img class="nt-head-img" :src="vo.head_url" alt="">
                    <div class="nt-name-t">{{vo.user_name}}</div>
                  </div>

                  <div class="n1-top-content">{{vo.signboard.title}}</div>

                  <div class="n1-bot-body">
                    <div class="n1-bot-left">
                      <div class="n1-left-title">{{vo.signboard.publish_name}}</div>
                      <span class="n1-left-spk">{{vo.signboard.address}}，{{vo.signboard.city_name}} - {{vo.signboard.province_name}}</span>
                    </div>
                    <div class="n1-bot-right" @click="$router.push('/zpInfo?id='+vo.id)">
                      招牌享阅
                    </div>
                  </div>

                  <div class="n1-bot-time">
                    {{vo.create_time}}
                  </div>

                </div>

              </div>
            </div>
            <!--招牌玩家 end-->

            <!--焦点时刻start-->
            <div v-else-if="vo.type == 5">
                <div class="new2-title" @click="toUserInfo(vo.user_id)">{{vo.user_name}}</div>
                <el-image class="n2-top-img" :src="vo.imgList[0]" fit="cover"></el-image>
                <div class="n2-head-img-d">
                  <img class="n2-head-img" @click="toUserInfo(vo.user_id)" :src="vo.head_url" alt="">
                </div>
                <div class="pdlr10">
                  <div class="n2-content">{{vo.spk}}</div>
                  <div class="n2-time">{{vo.create_time}}</div>
                </div>
                <div class="Interflow interflow-new2">
                  <div class="interflow2">
                    <div v-show="!vo.is_focus">
                      <div v-if="vo.is_highlight" class="icon" @click="onHighlight(key)">
                        <img src="../../static/icon/highlighton.png" alt="">
                      </div>
                      <div v-else class="icon" @click="onHighlight(key)">
                        <img src="../../static/icon/highlight.png" alt="">
                      </div>
                    </div>
                    <div class="word new2-word">
                      <input
                              type="text"
                              @focus="focusInput(key)"
                              @blur="hideInput(key)"
                              v-model="vo.interflowContent"
                              placeholder="Interflow…"
                      >
                    </div>
                    <div
                            class="button"
                            :class="vo.interflowContent ? 'active' : ''"
                            v-show="vo.is_focus == true"
                            @click="subInterflow(key)"
                    >Post</div>
                  </div>

                  <div>
                    <span class="new2-high-num">{{vo.highlight_num}}次Highlight</span>
                    <span class="new2-fy-all" style="cursor: pointer;" @click="toSeeinterflow(key)">全部{{vo.leave_num}}条发言</span>
                  </div>

                </div>
            </div>
            <!--焦点时刻end-->

            <!--博文start-->
            <div v-else-if="vo.type == 6">
                <div class="bw-body">
                  <div class="bw-title">{{vo.title}}</div>

                  <div class="bw-user" style="display: flex;justify-content: space-between;align-items: center;">
                    <div>
                      <span class="bw-name" @click="toUserInfo(vo.user_id)">{{vo.user_name}}</span>
                      <span class="bw-time">{{vo.create_time}}</span>
                    </div>
                    <div>
                      <span @click="$router.push('/fullText?id='+vo.id)" class="bw-de">阅读全文</span>
                    </div>

                  </div>

                  <div class="bw-content">
<!--
                    <div style="display: inline-block;" v-html="vo.content.replace(/<\/?(img)[^>]*>/gi, '')"></div>
-->

                  </div>

                </div>
                <el-image class="bw-img" fit="cover" :src="vo.imgList[0]"></el-image>
            </div>
            <!--博文end-->



            <!--赛事预测 start-->
            <div v-else-if="vo.type == 7 && !vo.athletics.jieguo">
                <div class="saishi-body">

                   <div class="saishi-t-time">{{vo.athletics.title}} <span style="margin-left: 10px;">{{vo.athletics.bs_time}}</span>  </div>
                    <div style="text-align: center;">
                      <span style="padding-bottom: 4px;border-bottom: 2px solid #DB1B7E;">预测:{{vo.athletics.spk}}</span>
                    </div>

                  <div class="v-dw-logo-body">
                    <div class="v-dw-name-bodu">
                      <div class="dw-name" style="font-size: 14px;">{{vo.athletics.troops1_name}}</div>
                      <div class="zc-b"><img style="width: 35px" src="../../static/icon/zc.png" alt=""></div>
                      <el-image class="dw-logo" :src="vo.athletics.troops1_img_url" fit="cover"></el-image>
                    </div>
                    <div class="vs-v"><img src="../../static/icon/vs.png" alt=""></div>
                    <div class="v-dw-name-bodu">
                      <div class="dw-name" style="font-size: 14px;">{{vo.athletics.troops2_name}}</div>
                      <el-image class="dw-logo" :src="vo.athletics.troops2_img_url" fit="cover"></el-image>
                    </div>
                  </div>

                </div>

                <el-image class="jj-big-img" :src="vo.athletics.img_url" fit="cover"></el-image>

              <div class="ss-body">
                <div class="topHead" @click="toUserInfo(vo.user_id)">
                  <img :src="vo.head_url" alt="">
                  <div class="left">
                    <router-link to class="name">{{vo.user_name}}</router-link>
                    <div class="time">{{vo.create_time}}</div>
                  </div>
                </div>
                <div class="ss-yc">赛事预测</div>
              </div>


                <div class="saishi-contents">{{vo.athletics.reason}}</div>
                <div class="saishi-high-num"  v-if="vo.highlight_num > 0">
                  {{vo.highlight_num}}次Highlight
                </div>

                <div class="message message2">
                  <div class="speakNum mt12">
                    <span class="toAll" v-if="vo.leave_num > 0"
                          @click="toSeeinterflow(key)">全部{{vo.leave_num}}条发言</span>
                    <span v-if="vo.linker_type == 1" class="yellowR"><img src="../../static/icon/wfy.png" alt=""></span>
                    <span v-else-if="vo.linker_type == 2" class="yellowR"><img src="../../static/icon/wzs.png" alt=""></span>
                    <span v-else-if="vo.linker_type == 3" class="yellowR"><img src="../../static/icon/yjz.png" alt=""></span>
                    <span class="noSpeak">{{vo.linker_spk}}</span>
                  </div>
                  <div class="mt12" v-if="vo.leaveList.length>0">
                    <div class="name" v-for="(leave,index) in vo.leaveList" :key="index">
                      <span class="nameWord">{{leave.user_name}}</span>
                      {{leave.content}}
                    </div>
                  </div>
                </div>

                <div class="Interflow">
                  <div v-show="!vo.is_focus">
                    <div v-if="vo.is_highlight" @click="onHighlight(key)" class="icon">
                      <img src="../../static/icon/highlighton.png" alt="">
                    </div>
                    <div v-else class="icon" @click="onHighlight(key)">
                      <img src="../../static/icon/highlight.png" alt="">
                    </div>
                  </div>
                  <div class="word">
                    <input
                            type="text"
                            @focus="focusInput(key)"
                            @blur="hideInput(key)"
                            v-model="vo.interflowContent"
                            placeholder="Interflow…"
                    >
                  </div>
                  <div
                          class="button"
                          :class="vo.interflowContent ? 'active' : ''"
                          v-show="vo.is_focus == true"
                          @click="subInterflow(key)"
                  >Post</div>
                </div>
              </div>
            <!--赛事预测 end-->

            <!--赛事预测结果 start-->
            <div v-else-if="vo.type == 7 && vo.athletics.jieguo">
              <div class="saishi-body">

                <div class="saishi-t-time">{{vo.athletics.title}} <span style="margin-left: 10px;">{{vo.athletics.bs_time}}</span>  </div>
                <div style="text-align: center;">
                  <span style="padding-bottom: 4px;border-bottom: 2px solid #DB1B7E;">预测:{{vo.athletics.spk}}</span>
                </div>

                <div class="v-dw-logo-body">
                  <div class="v-dw-name-bodu" style="width: 220px;">
                    <div class="dw-name" style="font-size: 14px;">{{vo.athletics.troops1_name}}</div>
                    <div class="zc-b">主场</div>
                    <el-image class="dw-logo" :src="vo.athletics.troops1_img_url" fit="cover"></el-image>
                    <div class="dw-sc">{{vo.athletics.troops1_score}}</div>
                  </div>
                  <div>:</div>
                  <div class="v-dw-name-bodu" style="width: 220px;">
                    <div class="dw-sc">{{vo.athletics.troops2_score}}</div>
                    <div class="dw-name" style="font-size: 14px;">{{vo.athletics.troops2_name}}</div>
                    <el-image class="dw-logo" :src="vo.athletics.troops2_img_url" fit="cover"></el-image>
                  </div>
                </div>

              </div>

              <div style="position: relative;">
                <el-image class="jj-big-img" :src="vo.athletics.img_url" fit="cover"></el-image>

                <img v-if="vo.athletics.jieguo == 1" class="sy-img" src="/static/icon/ying.png" alt="">
                <img v-else-if="vo.athletics.jieguo == 2" class="sy-img" src="/static/icon/shu.png" alt="">
                <img v-else class="sy-img" src="/static/icon/zou.png" alt="">

              </div>


              <div class="ss-body">
                <div class="topHead" @click="toUserInfo(vo.user_id)">
                  <img :src="vo.head_url" alt="">
                  <div class="left">
                    <router-link to class="name">{{vo.user_name}}</router-link>
                    <div class="time">{{vo.create_time}}</div>
                  </div>
                </div>
                <div class="ss-yc">赛事预测</div>
              </div>


              <div class="saishi-contents">{{vo.athletics.reason}}</div>
              <div class="saishi-high-num"  v-if="vo.highlight_num > 0">
                {{vo.highlight_num}}次Highlight
              </div>

              <div class="message message2">
                <div class="speakNum mt12">
                    <span class="toAll" v-if="vo.leave_num > 0"
                          @click="toSeeinterflow(key)">全部{{vo.leave_num}}条发言</span>
                  <span v-if="vo.linker_type == 1" class="yellowR"><img src="../../static/icon/wfy.png" alt=""></span>
                  <span v-else-if="vo.linker_type == 2" class="yellowR"><img src="../../static/icon/wzs.png" alt=""></span>
                  <span v-else-if="vo.linker_type == 3" class="yellowR"><img src="../../static/icon/yjz.png" alt=""></span>
                  <span class="noSpeak">{{vo.linker_spk}}</span>
                </div>
                <div class="mt12" v-if="vo.leaveList.length>0">
                  <div class="name" v-for="(leave,index) in vo.leaveList" :key="index">
                    <span class="nameWord">{{leave.user_name}}</span>
                    {{leave.content}}
                  </div>
                </div>
              </div>

              <div class="Interflow">
                <div v-show="!vo.is_focus">
                  <div v-if="vo.is_highlight" @click="onHighlight(key)" class="icon">
                    <img src="../../static/icon/highlighton.png" alt="">
                  </div>
                  <div v-else class="icon" @click="onHighlight(key)">
                    <img src="../../static/icon/highlight.png" alt="">
                  </div>
                </div>
                <div class="word">
                  <input
                          type="text"
                          @focus="focusInput(key)"
                          @blur="hideInput(key)"
                          v-model="vo.interflowContent"
                          placeholder="Interflow…"
                  >
                </div>
                <div
                        class="button"
                        :class="vo.interflowContent ? 'active' : ''"
                        v-show="vo.is_focus == true"
                        @click="subInterflow(key)"
                >Post</div>
              </div>
            </div>
            <!--赛事预测结果 end-->


            <!--问答1 start-->
            <div v-else-if="vo.type == 8">
                <div class="ask-body">

                  <div v-if="vo.question.put_user_id == userInfo.id">
                    <span class="top1-name">You</span>
                    <span class="top1-spk"> Ask to  </span>
                    <span class="top1-spk" @click="toUserInfo(vo.question.answer_user_id)">{{vo.question.answer_user_name}}</span> :
                  </div>

                  <div v-else-if="vo.question.answer_user_id == userInfo.id">
                    <span class="top1-name" @click="toUserInfo(vo.question.anstion_user_id)">{{vo.question.put_user_name}}</span>
                    <span class="top1-spk"> Ask to  </span>
                    <span class="top1-spk">You</span> :
                  </div>

                  <div v-else>
                    <span class="top1-name" @click="toUserInfo(vo.question.put_user_id)">{{vo.question.put_user_name}}</span>
                    <span class="top1-spk"> Ask to  </span>
                    <span class="top1-spk" @click="toUserInfo(vo.question.answer_user_id)">{{vo.question.answer_user_name}}</span> :
                  </div>


                  <div class="ask-content">{{vo.question.question_info}}</div>

                  <div class="ask-btn-body" v-if="vo.question.answer_user_id == userInfo.id && vo.question.status == 1">
                    <div class="ask-yes"  @click="$router.push('/answerQ?id='+vo.id)">开始回答</div>
                    <div class="ask-no" @click="onRefuse(key)">拒绝/drop this</div>
                  </div>

                  <div class="ask-time">{{vo.create_time}}</div>
                  <div class="ask-spkm" v-if="vo.question.put_user_id == userInfo.id && vo.question.status == 3">{{vo.question.answer_user_name}}未能回复你的提问.</div>
                </div>

                <div class="askto-body" v-if="vo.question.status == 2">
                  <div class="askto-left" @click="toUserInfo(vo.question.answer_user_id)">
                    <img :src="vo.question.answer_user_head" alt="">
                  </div>
                  <div class="askto-right">{{vo.question.result_info}}</div>
                </div>

                <div class="ask-bootm-body">
                  <div class="ask-level-num" v-if="vo.leave_num > 0" @click="toSeeinterflow(key)">全部{{vo.leave_num}}条发言</div>
                  <div class="ask-interflow">
                    <div class="ask-input-body">
                      <input type="text" @focus="focusInput(key)" @blur="hideInput(key)" v-model="vo.interflowContent" placeholder="Interflow…">
                    </div>
                    <div class="button" :class="vo.interflowContent ? 'active' : ''" v-show="vo.is_focus == true" @click="subInterflow(key)">Post</div>
                  </div>
                </div>
            </div>
            <!--问答1 end-->

            <div v-else>{{vo.type_text}}</div>
          </div>
          <!-- 事物内容 end -->


        </div>
      </div>
    </div>


    <div class="slelect-linker-body" :style="'top:'+(infoBodyShow?'115px':'65px')+';width:'+selectLinkerW+'px;'">
      <div class="slelect-linker-body2">

        <div class="slke-sq-body">
          <div class="sl-list-body">
            <div class="sl-top-body">
              <div>找一找您的linker提出提问？</div>
              <div @click="selectLinker()" class="sl-sq">收起</div>
            </div>
          </div>
          <div class="sl-xt"></div>
        </div>


        <div class="sl-list-body">
          <div style="height: 60px;"></div>
          <div class="sl-list" @click="$router.push('/askQ?id='+vo.user_id)" v-for="(vo,key) in linkerList" :key="key">
            <div class="sl-left">
              <el-image class="linker-head" fit="cover" :src="vo.head_url"></el-image>
            </div>
            <div class="sl-right">
              <div class="linker-name">{{vo.user_name}}</div>
              <div class="linker-spk">{{vo.zyly}} ` {{vo.zyly_year}}</div>
              <div class="linker-spk link-city">{{vo.area_text}}</div>
              <div class="linker-spk">{{vo.swfu}} - {{vo.swfu_year}}</div>
            </div>
          </div>
          <div style="height: 120px;"></div>
        </div>
      </div>
    </div>
    <!--加载更多-->
<!--    <div
      style="margin-top: 40px;"
      class="loading"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(246, 246, 246, 0.8)"
    ></div>-->


    <div>{{inputStr}}</div>
  </div>
</template>

<script>
import Topheader from "../components/header"; //上传图片
export default {
  name: "App",
  data() {
    return {
        is_gongkai:1,//是否公开
      inputStr: "",
      imgHeight: 400, //轮播图高度自适应
      bannerIndex: "", //轮播图下标
      hideUpload: false, //上传图片，超出12张就隐藏
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      name: "",
      email: "",
      passWord: "",
      postNum: 0,
      postWord: "", //post,发送
      homePhotoUpNum: 1, //tab
      upPictrue: false, //tab切换显示上传文字
      upImgStates: false, //上传图片隐藏

      dialogImageUrl: "",
      dialogVisible: false, //上传图片
      content: "", //textarea文字
      imgs_id: [], //图片id
      textareaL: "", //textarea长度
      interflowL: true, //获取textarea长度
      interflowWord: "", //
      Inform: {}, //公告信息
      yesterdayUser: {}, //昨日人物
      highlightInfo: {}, //大赏推荐
      rmdInfo: {}, //推荐用户
      list: [],
      page: 1,
      page_num: 5,
      loading: false,
      loadingType: 0, //0=可以加载 1=加载中 2=已加载完毕
        imgList:[],
        infoBodyShow:true,//顶部条状是否显示
        huidaShow:true,//回答数量

        /*临时使用变量*/
        is_focus:false,
        is_highlight:false,
        interflowContent:'',
        isLinkers:false,//是否linker 菜单
        linker_type:1,
        stsShow:false,//选择查看方式
        stsType:1,//1=全部 2=你的
        selectLinkerW:0,//宽度
        seleIn:null,
        linkerList:[],//linker 数组
        answerMyInfo:{
            num:0,
            userName:''
        },
        jiaoliuNum:0,
    };
  },
    watch:{
        // 方法1
        '$route' (to, from) { //监听路由是否变化
            //获取文章数据
            this.isLinkers=this.$route.query.isLinkers;//
            this.getList();//请求数据
            if (this.isLinkers == 'true'){
                this.getJiaoliuNum();
            }
        }
    }
  ,
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#CBCBCB");
      this.getUserInfo();
      this.infoBodyShow=!this.userInfo.yesOrNoAllSet;//全部设定
  },
  created() {
    this.isLinkers=this.$route.query.isLinkers;//
    this.getList(); //获取列表
    this.getInform(); //获取公告
    this.getYesterdayUser(); //获取昨日人物
    this.getHighlightInfo(); //大赏信息
    this.getRmdInfo(); //推荐用户
    this.getAnswerMy();//获取回答我的

    if (this.isLinkers == 'true'){
        this.getJiaoliuNum();//获取交流数量
    }


    window.addEventListener("scroll", this.onScroll);
  },
  methods: {
      //点击是否公开信息
      onIsGongkai(){
        let _this=this;
        _this.is_gongkai = _this.is_gongkai == 1 ? 2:1;
      },
      toBeian(){
          window.open('https://beian.miit.gov.cn/#/Integrated/index');
      },
      //获取交流数量
      getJiaoliuNum(){
          let _this=this;
          _this.common.request('api/dynamicLeave/getJiaoLiuNum',{},function(res){
              if(res.status == 200){
                  _this.jiaoliuNum=res.data.num;
              }
          })
      },
      //关闭活跃
      closHuoyue(){
          let _this=this;
          _this.common.request('api/user/closeHuoyue',{},function(res){
              if(res.status == 200){
                  _this.userInfo=res.data;
                  localStorage.setItem("userInfo", JSON.stringify(res.data));
              }
          },'post')
      },
      //获取用户信息
      getUserInfo(){
        let _this=this;
        _this.common.request('api/user/allInfo',{},function (res) {
            if(res.status == 200){
                _this.userInfo=res.data;
                localStorage.setItem("userInfo", JSON.stringify(res.data));
            }
        })
      },
      //获取回答我的
      getAnswerMy(){
        let _this=this;
        _this.common.request('api/index/answerMyQuestion',{},function (res) {
            if(res.status == 200){
                _this.answerMyInfo=res.data;
            }
        })
      },
      onRefuse(key){
        let _this=this;
          let info=_this.list[key];
          _this.common.request('api/question/refuse',{dynamic_id:info.id},function (res) {
              if(res.status == 200){
                  _this.common.vMessage(res.message);
                  _this.list[key].question.status = 3;//
              }
          },'post')
      },
      //选择linker提问
      selectLinker(){
        let _this=this;
          clearInterval(_this.seleIn);
          //关闭
          if(this.selectLinkerW > 0){
            this.seleIn=setInterval(function () {
                _this.selectLinkerW-=8;
                if (_this.selectLinkerW<=0){
                    clearInterval(_this.seleIn);
                }
            },1);
        }else {
              //开启
              //请求linker 数据
              let data={
                  page_num:10000
              };
              _this.common.request('api/userLinker/myLinkerList',data,function (res) {
                  _this.linkerList=res.data.list;
              });
            this.seleIn=setInterval(function () {
                _this.selectLinkerW+=8;
                if (_this.selectLinkerW>=368){
                    clearInterval(_this.seleIn);
                }
            },1);
        }
      },
      //选择方式
      selectShow(){
        this.stsShow=!this.stsShow;
      },
      changeSts(){
          let _this=this;
          this.selectShow();
          _this.common.request('api/user/changeHyType',{},function (res) {
             if(res.status == 200){
                 _this.userInfo=res.data;
                 localStorage.setItem("userInfo", JSON.stringify(res.data));
                 _this.getList();//重新获取动态事务
             }
          },'post');
      },
      /*临时使用方法*/
      focusInputNew(){
        this. is_focus=!this.is_focus;
      },

      //关闭回答
      closeHuida(){
          let _this=this;
          _this.common.request('api/user/closeHuida',{},function (res) {
              if(res.status == 200){
                  _this.userInfo=res.data;
                  localStorage.setItem("userInfo", JSON.stringify(res.data));
              }
          },'post');
      },
    //清空已上传
    clearUploadedImage() {
      this.$refs["my-upload"].clearFiles();
      this.imgs_id = []; //图片id
    },
    changeBanner(e) {
      if (e > 0) {
        this.imgHeight = 200;
      } else {
        this.imgHeight = 400;
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPEG 或 JPG 或 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //去看全部
    toSeeinterflow(key) {
      let _this = this;
      this.$router.push({
        path: "/seeinterflow",
        query: {
          id: _this.list[key].id
        }
      });
    },
    //点击高光
    onHighlight(key) {
      let _this = this;
      let id = _this.list[key].id;
      _this.common.request(
        "api/dynamic/highlight",
        { id: id },
        function(res) {
          if (res.status == 200) {
            _this.common.vMessage(res.message);
            _this.list[key].highlight_num = res.data.highlight_num; //
            _this.list[key].is_highlight = !_this.list[key].is_highlight; //
          }
        },
        "post"
      );
    },
    //留言
    subInterflow(key) {
      let _this = this;
      if (!_this.list[key].interflowContent) {
        this.hideInput(key);
        return;
      }
      let data = {
        dynamic_id: _this.list[key].id,
        content: _this.list[key].interflowContent,
        page_num: 3
      };
      _this.common.request(
        "api/dynamicLeave/interflow",
        data,
        function(res) {
          if (res.status == 200) {
            _this.common.vMessage(res.message);
            _this.list[key].leave_num = res.data.leave_num;
            _this.list[key].leaveList = res.data.leaveList; //更新发言
            _this.list[key].interflowContent = null;
            _this.blurInput(key);
          }
        },
        "post"
      );
    },
    getList() {
      let _this = this;
      _this.page = 1;
      let data = {
        page: _this.page,
        page_num: _this.page_num,
          c_type:'web'
      };
      if (this.isLinkers == 'true'){
          data.linkers=1
      }
      //没有登陆则返回
      if(!_this.common.isLogin()){
          return;
      }
      _this.common.request("api/dynamic/homeList", data, function(res) {
        if (res.status == 200) {
          _this.list = res.data.list;
          for (let i = 0; i < _this.list.length; i++) {
              //查看大图(新)
              let ss=[];
              for (let j=0;j<_this.list[i].imgList.length;j++){
                  ss.push(_this.list[i].imgList[j]);
              }
              _this.imgList[i]=ss;


            if (_this.list[i].highlight_num > 0 || _this.list[i].content) {
              //刘欢
              _this.$nextTick(() => {
                  if(_this.$refs["wordH" + i]){
                      let scrollHeight = _this.$refs["wordH" + i][0].scrollHeight;
                      _this.list[i].height = scrollHeight;
                      _this.inputStr += " ";
                  }

              });
            }
          }
        }
      });
    },

    //加载跟多
    onScroll() {
      //可滚动容器的高度
      let innerHeight = document.querySelector("#app").clientHeight;
      //屏幕尺寸高度
      let outerHeight = document.documentElement.clientHeight;
      //可滚动容器超出当前窗口显示范围的高度
      let scrollTop = document.documentElement.scrollTop;
      //scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，严格来讲，是接近底部。
      if (innerHeight <= outerHeight + scrollTop) {
        let _this = this;
        if (_this.loadingType != 0) {
          return;
        }
        _this.loadingType = 1;
        _this.loading = true;
        _this.page++;
        let list = [];
        let data = {
          page: _this.page,
          page_num: _this.page_num,
            c_type:'web'
        };
          if (this.isLinkers == 'true'){
              data.linkers=1
          }
        _this.common.request("api/dynamic/homeList", data, function(res) {
          if (res.status == 200) {
            list = res.data.list; //请求数据
            _this.loading = false;
            if (list.length <= 0) {
              _this.loadingType = 2;
              return;
            }
            let newLen=list.length;//
              let oldLen=_this.list.length;//旧的长度
            _this.list = _this.list.concat(list);
            for (let i = oldLen; i < _this.list.length; i++) {
                //查看大图(新)
                let ss=[];
                for (let j=0;j<_this.list[i].imgList.length;j++){
                    ss.push(_this.list[i].imgList[j]);
                }
                _this.imgList[i]=ss;

            if (_this.list[i].highlight_num > 0 || _this.list[i].content) {
              //刘欢
              _this.$nextTick(() => {
                  if(_this.$refs["wordH" + i]){
                      let scrollHeight = _this.$refs["wordH" + i][0].scrollHeight;
                      _this.list[i].height = scrollHeight;
                      _this.inputStr += " ";
                  }

              });
            }
          }


            _this.loadingType = 0;
          }
        });
      }
    },
    //获取头部 textarea 长度
    textareaF() {
      this.textareaL = this.content.length;
    },

    focusInput(key) {
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].is_focus = false;
      }
      this.list[key].is_focus = true;
      this.inputStr += " ";
    },
    hideInput(key) {
      if (!this.list[key].interflowContent) {
        this.list[key].is_focus = false;
        this.inputStr += " ";
      }
    },
    blurInput(key) {
      this.list[key].is_focus = false;
      this.inputStr += " ";
    },
    //获取推荐用户
    getRmdInfo() {
      let _this = this;
      _this.common.request("api/user/rmdInfo", {}, function(res) {
        if (res.status == 200) {
          _this.rmdInfo = res.data;
        }
      });
    },
    //获取大赏信息
    getHighlightInfo() {
      let _this = this;
      _this.common.request("api/user/highlightInfo", {}, function(res) {
        if (res.status == 200) {
          _this.highlightInfo = res.data;
        }
      });
    },
    //去用户主页
    toUserInfo(id) {
      this.$router.push({
        path: "/userInfo",
        query: {
          id: id
        }
      });
    },
    //点击昨日人物
    onClickDayUser(id) {
      let _this = this;
      _this.common.request(
        "api/user/onClickDayUser",
        { id: id },
        function(res) {},
        "post"
      );
      _this.toUserInfo(id);
    },
    //发布动态
    dynamicPost() {
      let _this = this;
      let type = this.upPictrue ? 2 : 1; //默认发布纯文字
      if (this.content.length > 400) {
        _this.common.vMessage("很抱歉，你要说的话超出了400字！", "warning");
        return;
      }
      _this.common.request(
        "api/dynamic/add",
        { content: _this.content, type: type, imgs_id: _this.imgs_id,is_gongkai:_this.is_gongkai },
        function(res) {
          if (res.status == 200) {
            if (document.getElementsByClassName("el-message").length < 1) {
              _this.$message({
                message: res.message,
                type: "success",
                duration: 2500,
                center: true,
                onClose: function(res) {
                  _this.content = '';
                  _this.textareaF();//获取一下长度
                  _this.upImgStates = false;
                  _this.getList(); //获取列表

                  //清空上传图片
                  _this.clearUploadedImage();
                }
              });
            }
          }
        },
        "post"
      );
    },
    //获取公告
    getInform() {
      let _this = this;
      _this.common.request("api/inform/one", {}, function(res) {
        if (res.status == 200) {
          _this.Inform = res.data;
        }
      });
    },
    //关闭公告
    closeInform() {
      let _this = this;
      _this.common.request(
        "api/inform/off",
        { id: _this.Inform.id },
        function(res) {
          if (res.status == 200) {
            _this.Inform = {};
          }
        },
        "post"
      );
    },
    //获取昨日人物
    getYesterdayUser() {
      let _this = this;
      _this.common.request("api/userClickNum/yesterdayUser", {}, function(res) {
        if (res.status == 200) {
          _this.yesterdayUser = res.data;
        }
      });
    },

    //post
    homePhotoUP(num) {
      let _this = this;
      _this.homePhotoUpNum = num;
      if (num == 2) {
        _this.upPictrue = true;
      } else if (num == 1) {
        _this.upPictrue = false;
      }
    },

    //显示上传图片
    upImg() {
      this.upImgStates = true;
    },

    //关闭上传图片
    close() {
      //this.upPictrue = false; //隐藏上传文字
      this.upImgStates = false; //隐藏上传图片
      // this.homePhotoUpNum = 1;
    },

    // 删除图片
    handleRemove(file, fileList) {
      let imgs_id = [];
      for (var i = 0; i < fileList.length; i++) {
        imgs_id[i] = fileList[i].response.data.id; //获得新的图片id
      }
      this.imgs_id = imgs_id; //保存数据
      this.hideUpload = this.imgs_id.length >= 12;
    },
    //上传接口图片
    handleAvatarSuccess(res, file) {
      this.imgs_id.push(res.data.id);
      this.hideUpload = this.imgs_id.length >= 12;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //限制上传个数,做提示
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 12个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },

    //展开
    zanF(key) {
      this.list[key].is_zank = !this.list[key].is_zank;
      this.inputStr += " ";
    }
  },
  components: {
    Topheader
  }
};
</script>

<style  lang='less'   rel="stylesheet/less">
  .el-carousel__container{
    height: 400px!important;
  }
  .user-tip{
    font-size:12px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(123,123,123,1);
    line-height: 30px;
  }
  .user-tip:hover{
    text-decoration: underline;
  }
// 上传图片的样式
.hide .el-upload--picture-card {
  display: none;
}
.upPicture {
  .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    object-fit: cover;
  }
  .el-upload-list--picture-card {
    padding: 0 3px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    margin: 0 3px 3px 0 !important;
  }
  .el-upload-list--picture-card .el-upload-list__item,
  .el-upload--picture-card {
    width: 64px !important;
    height: 64px !important;
    line-height: 64px !important;
    position: relative;
    border-radius: 0 !important;
    border: none !important;
  }
  .el-upload--picture-card i {
    width: 64px !important;
    height: 64px !important;
    line-height: 64px !important;
    text-align: center;
    background: #d7d7d7;
  }
  .el-icon-plus:before {
    color: #fff;
  }
  .el-upload-list--picture-card .el-upload-list__item .el-icon-check {
    position: absolute;
    right: 15px;
  }
  .el-upload--picture-card:hover,
  .el-upload:focus {
    border-color: #fff;
    color: #fff;
  }
}
</style>

<style scoped lang='less'  rel="stylesheet/less">
@import "../assets/css/index.less";
body {
  background: #cbcbcb;
}

.toAll {
  cursor: pointer;
}
.toAll:hover {
  text-decoration: underline;
}
.head_body {
  display: flex;
  justify-content: flex-start;
}
.w554 {
  width: 554px;
  margin: 0 auto;
}

.home {
  margin: 16px 0 10px 206px;
  .center {
    width: 544px;
    position: absolute;
  }
}

// post
.postMsg {
  background: #fff;
  .tabs {
    margin: 0 14px;
    padding: 10px 14px;
    border-bottom: 1px solid #e9e9e9;
    .flexStart;
    .word {
      color: #20709b;
      font-size: 14px;
      margin-right: 30px;
      cursor: pointer;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }
    .word:hover {
      // border-bottom: 1px solid #d6d6d6;
    }
    .word.active {
      position: relative;
      color: #484848;
    }
    .word.active::before {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 50%;
      margin-left: -12px;
      width: 40px;
      height: 2px;
      background: #1c1c1c;
    }
    img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
  .fromWord {
    padding: 14px;
    color: #afafaf;

    textarea {
      color: #000;
      font-size: 14px;
      height: 51px;
      outline: none;
      resize: none;
      width: 100%;
      border: none;
    }
  }
  .post {
    .flexSBetween;
    border-top: 1px solid #d6d6d6;
    padding: 10px 14px;
    position: relative;

    .pictureNum {
      .flexSBetween;
      padding: 8px 2px;
      .num {
        color: #373737;
        font-size: 16px;
      }
      .close {
        width: 20px;
        height: 20px;
        line-height: 20px;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        cursor: pointer;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
    .picture {
      color: #787878;
      font-size: 14px;
      .flexStart;
      .add {
        width: 18px;
        height: 18px;
        margin-right: 12px;
        color: #fff;
        text-align: center;
        cursor: pointer;
      }
    }
    .button {
      color: #15a3f5;
      font-size: 14px;
      width: 62px;
      height: 26px;
      line-height: 26px;
      background: #e8e8e8;
      border-radius: 13px;
      text-align: center;
      cursor: pointer;
    }
    .button.active {
      color: #fff;
      background: #15a3f5;
    }
    .button:hover {
      color: #fff;
      background: #15a3f5;
    }
    .upPicture {
      background: #fff;
      box-shadow: 0px 5px 8px 0px rgba(78, 78, 78, 1);
      position: absolute;
      top: 59px;
      left: 14px;
      z-index: 9;
      width: 278px;
      height: 256px;
      padding: 2px;
      .Img {
        .imgCover(64px, 64px);
      }
    }
  }
}

.user-name{
  font-size:16px!important;
  font-family:Microsoft YaHei;
  font-weight:400!important;
  color:rgba(28,68,105,1)!important;
}

// 欢迎加入
.joinUs {
  margin-top: 16px;
  background: #fff;
  padding: 18px 14px;
  .flexStart;
  position: relative;
  .close {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    cursor: pointer;
  }
  .left {
    width: 94px;
    margin-right: 14px;
    img {
      width: 94px;
      height: 94px;
    }
  }
  .right {
    .tit {
      color: #1c1c1c;
      font-size: 20px;
      font-weight: bold;
      .oneLines;
      height: 25px;
    }
    .word {
      color: #1c1c1c;
      font-size: 16px;
      margin-top: 15px;
      margin-bottom: 9px;
      .twoLines;
    }
    .smallWord {
      color: #7f7f7f;
      font-size: 14px;
      height: 20px;
      .oneLines;
    }
  }
}

// 更新视图

.el-carousel__container {
  position: relative;
  height: 100% !important;
}
.el-carousel__indicators--outside {
  bottom: -20px !important;
}
.news {
  margin-top: 14px;
  background: #fff;
  //头像
  .topHead {
    padding: 14px;
    .flexStart;
    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 14px;
      cursor: pointer;
    }
    .left {
      .name {
        color: #1d1d1d;
        font-size: 14px;
        font-weight: bold;
      }
      .name:hover {
        text-decoration: underline;
        font-weight: bold;
        color: #08486d;
      }
      .time {
        color: #7f7f7f;
        font-size: 12px;
        margin-top: 8px;
      }
    }
  }

  // 图片
  .picture {
    width: 544px;
    line-height: 0;
    position: relative;
    .img {
      width: 100%;
      line-height: 0;
    }
  }
  .picture22 {
    width: 100%;
    max-height: 544px;
    overflow: hidden;
    img {
      width: 100%;
      max-height: 544px;
      overflow: hidden;
  
    }
  }

  //图片带banner
  .pictureBanner {
    .imgCover(544px, 544px);
  }

  //发言
  .message {
    padding: 14px;
    .num {
      color: #282a2b;
      font-size: 14px;
      margin-bottom: 15px;
      font-weight: bold;
    }
    .num.typeTwo {
      margin-top: 14px;
    }
    .word {
      color: #484848;
      font-size: 14px;
      line-height: 24px;
      font-weight: normal;
      position: relative;
      .zan{
        position: absolute;
        bottom:-2px;
        right: 0;
        font-size: 14px;
        background:#fff;

      }
    }
    .word.typeTwo {
      margin-top: 14px;
    }
    .speakNum {
      color: #7f7f7f;
      font-size: 14px;
      .flexStart;
    }
    .speakNum.mb12 {
      margin-bottom: 12px;
    }
    .yellowR {
      width: 14px;
      height: 14px;
      display: inline-block;
      margin: 0 8px 0px 14px;
    }
    .yellowR.mb14 {
      margin: 0 8px 14px 14px;
    }
    .noSpeak {
      margin-top: -2px;
    }
    .name {
      margin-bottom: 8px;
      margin-right: 88px;
      color: #484848;
      font-weight: 400;

      .nameWord {
        font-weight: bold;
      }
      color: #4d4d4d;
      font-size: 14px;
    }
    .name:last-child {
      margin-bottom: 0;
    }
  }

  //Interflow
  .Interflow {
    .flexStart;
    border-top: 1px solid #e6e5e5;
    padding: 14px 0;
    margin: 0 14px;
    .icon {
      width: 22px;
      height: 22px;
      margin-right: 15px;
      cursor: pointer;
    }
    .word {
      color: #7f7f7f;
      font-size: 14px;
      width: 100%;
    }
    .button {
      color: #15a3f5;
      font-size: 14px;
      width: 62px;
      height: 26px;
      line-height: 26px;
      background: #e8e8e8;
      border-radius: 13px;
      text-align: center;
      cursor: pointer;
    }

    .button.active {
      color: #fff;
      background: #15a3f5;
    }
    .button:hover {
      color: #fff;
      background: #15a3f5;
    }
  }
}

// right

.homeRCont {
  padding: 36px 14px 0px 14px;
  background: #fff;
  .welcome {
    padding-bottom: 14px;
    border-bottom: 1px solid #e7e7e7;
  }
  .icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    display: block;
  }
  .welcomeName {
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(72,72,72,1);
    span {
      color: #166593;
      font-size: 14px;
    }
  }
  .welcome-title{
    .flexStart;
  }
  .welcome-spk{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(155,155,155,1);
    line-height:22px;
  }

  // 2
  .allPeople {
    margin-top: 14px;
    display: flex;
    justify-content: flex-start;
    .name {
      color: #7f7f7f;
      font-size: 14px;
      line-height: 20px;
      a {
        font-weight: bold;
        color: #166593;
      }
      span {
        color: #7f7f7f;
      }
      .sixPeople {
        color: #166593;
      }
    }
  }

  // 2.2
  .HLight {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #e7e7e7;
    padding-bottom: 14px;
    .HLightName {
      font-size: 14px;
      .name {
        color: #166593;
        margin-bottom: 14px;
        display: inline-block;
        font-weight: bold;
      }
      .word {
        font-weight: normal;
        color: #7e7e7e;
      }
    }
    .HLightImgNum {
      margin-bottom: 12px;
      .flexStart;
      .HLightImg {
        margin-left: 17px;
        a {
          display: inline-block;
          height: 38px;
          img {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            margin-left: -17px;
            border: 2px solid #fff;
            background: #c6c6c6;
          }
        }
      }
      .HLightNum {
        color: #1c1c1c;
        font-size: 14px;
        font-weight: bold;
        margin-left: 12px;
      }
      .word {
        color: #7f7f7f;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  // 3
  .dayNum {
    color: #737373;
    font-size: 14px;
    margin-top: 14px;
  }
  .dayName {
    color: #166593;
    font-size: 14px;
    font-weight: bold;
    margin-top: 16px;
    display: inline-block;
  }
  .dayWrod {
    color: #1c1c1c;
    font-size: 14px;
    margin-top: 9px;
  }
}
// 上传图片
.el-upload-list--picture-card .el-upload-list__item {
  width: 66px !important;
  height: 66px !important;
}
.avatar-uploader {
  .flexSBetween;
  ul {
    li {
      width: 66px !important;
      height: 66px !important;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #fff;
  background: #d7d7d7;
  width: 66px;
  height: 66px;
  line-height: 66px;
  text-align: center;
}
.avatar {
  width: 66px;
  height: 66px;
  display: block;
}
.follow-page {
  background-color: #f1f1f1;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #696969;
  text-indent: 14px;
}

// 左右
.homeLR {
  width: 1100px;
  height: 40px;
  position: fixed;
  left: 50%;
  margin-left: -550px;
  .left {
    position: absolute;
    top: 56px;
    left: 0;
    width: 186px;
    .name {
      margin-bottom: 10px;
      font-weight: 400;
      cursor: pointer;
      font-size: 14px;
      /*color: green;*/
      .flexStart;
      img {
        width: 18px;
        height: 18px;
        margin-right: 12px;
      }
      .headerImg {
        .border-radius(8px);
        width: 54px;
        height: 54px;
      }
      .names {
        color: #353535;
        font-size: 14px;
        align-items: center;
      }
      .names:hover {
        text-decoration: underline;
        font-weight: bold;
      }
    }
    .name:hover {
/*
      text-decoration: underline;
*/
      font-weight: bold;
    }
    .tit {
      color: #7f7f7f;
      font-size: 11px;
      margin: 14px 0;
    }
    .headerImg {
      .border-radius(8px);
      width: 54px;
      height: 54px;
    }
  }
  .right {
    position: absolute;
    top: 56px;
    right: 0;
    width: 336px;
  }
}

.wordHight {
  height: 70px!important;
    text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.zan {
  cursor: pointer;
  text-align: right;
  font-size:12px
}

.info-top-body{
  height:52px;
  background:rgba(218,225,232,1);
  position: fixed;
  top: 48px;
  width: 100%;

  z-index: 10;

}
.info-top-body .w1100{
  height: 100%;
}
  .top2-body{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
  }

  .top2-name{
    font-size:15px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(73,73,73,1);
    line-height:19px;
  }
  .t-sx{
    width:2px;
    height:31px;
    background:rgba(206,210,213,1);
    border-radius:1px;
  }
  .top2-list{
    font-size:15px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(22,101,147,1);
    text-align: center;
    padding: 0 20px;
    cursor: pointer;
  }
  .home-t{
    font-size:24px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(72,72,72,1);
    margin-bottom: 16px;
  }

  .kn-body{
    padding: 10px 0;
    border-bottom: 1px solid #E7E7E7;
    cursor: pointer;
  }
  .kn-spk1{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(152,152,152,1);
    line-height:20px;
  }
  .kn-icon{
    width:32px;
    height:32px;
    margin: 10px 0;
  }
  .kn-blue{
    font-size:20px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(28,68,105,1);
  }
  .kn-spk2{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(72,72,72,1);
    line-height:20px;
  }
  .kn-b-tex{
    font-size:12px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(152,152,152,1);
    line-height:25px;
  }

  .today-body{
    background-color: #FFF;
    margin-top: 20px;
    padding: 16px;
  }

  .today-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .today-time{
    font-size:15px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(182,159,118,1);
  }
  .today-close{

  }

  .today-close img{
    width:20px;
    height:20px;
  }
.today-close img:hover{
  cursor: pointer;
}
  .today-content{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 10px;
  }

  .td-user-list{
    text-align: center;
    width: 25%;
  }
  .td-user-list img{
    border-radius: 50%;
    width: 88px;
    height: 88px;
  }
  .td-name{
    font-size:15px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(72,72,72,1);
    margin-top: 10px;
  }
  .td-spk{
    font-size:12px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(89,89,89,1);
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .show-type-body{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }
  .s-t-xt{
    width:429px;
    height:1px;
    background:#D3D3D3;
  }
  .s-t-right{
    position: relative;
  }
  .slelect-sts-body{
    position: absolute;
    right: 0;
    bottom: -100px;
    width:160px;
    height:90px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 7px 1px rgba(114,114,114,0.66);
    border-radius:8px;
  }
  .slelect-sts-body p{
    text-indent: 20px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(125,125,125,1);
    cursor: pointer;
    border-left: 2px solid #FFF;
  }
.slelect-sts-body .sts-a{
    color: #166593;
  border-color: #166593;
  }
  .s-t-s1{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(116,139,161,1);
  }
  .s-t-s2{
    font-size:13px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(72,72,72,1);
    cursor: pointer;
  }

  .you-tj-body{
    background: #FFF;
    padding: 20px;
    margin-top: 10px;
  }
  .you-tage{
    width:76px;
    height:24px;
    background:rgba(138,116,83,1);
    border-radius:12px;
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(254,254,254,1);
    text-align: center;
    line-height: 24px;
  }
  .you-tj-content{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
  }
  .y-tj-left{
    position: relative;
    width: 100px;
    height: 60px;
  }

  .y-tj-img1{
    width:66px;
    height:42px;
    border-radius:8px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .y-tj-img2{
    width:66px;
    height:42px;
    border-radius:8px;
    right: 0;
    bottom: 0;
    position: absolute;
    z-index: 2;
  }

  .y-tj-right{
    margin-left: 10px;
    width: 400px;
    font-size:15px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(152,152,152,1);
    a {
      font-size:14px;
      font-family:Microsoft YaHei;
      font-weight:bold;
      color:rgba(53,53,53,1);
    }
  }
  .huida-body{
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFF;
    margin-top: 20px;
  }
.huida-left{
  margin-left: 10px;
}
.huida-name{
  font-size:16px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(53,53,53,1);
}
.huida-num{
  font-size:16px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(152,152,152,1);
  margin-left: 10px;
}

  .huida-right{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right: 10px;
  }
  .huida-cha{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(72,141,189,1);
    margin-right: 20px;
  }
.huida-close{
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
}
  
  /*new 事物*/
  .news1-top-body{

  }
.news1-top-body .n1-top-img{
  width: 100%;
  height: 200px;
}
  .n1-top-name-body{
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 35px;
  }
  .nt-head-img{
    width:54px;
    height:54px;
    border-radius:50%;
    position: absolute;
    left: 0;
    top: -25px;
  }
  .pdlr10{
    padding: 0 10px;
  }
  .nt-name-t{
    margin-left: 64px;
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(29,29,29,1);
  }
  .n1-top-content{
    font-size:24px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(29,29,29,1);
    line-height:38px;
  }
  .n1-bot-body{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .n1-left-title{
    font-size:18px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(29,29,29,1);
    line-height: 30px;
  }
  .n1-left-spk{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(89,89,89,1);
    line-height: 30px;
      border-bottom: 1px solid #D7D7D7;

  }
  .n1-bot-right{
    width:106px;
    height:30px;
    background:rgba(242,44,100,1);
    border-radius:18px;
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:30px;
    text-align: center;
      cursor: pointer;
  }
.n1-bot-right:hover{
    background:rgba(242,44,100,0.8);

}
  .n1-bot-left{
      width: 495px;

  }
  .n1-bot-time{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(87,87,87,1);
    line-height:40px;
    width: 116px;
  }

  .new2-title{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(72,72,72,1);
    line-height:40px;
    text-align: center;
  }

  .n2-top-img{
    width: 100%;
    height: 460px;
  }
  .n2-head-img-d{
    position: relative;
    height: 60px;
  }
  .n2-head-img{
    position: absolute;
    left: 50%;
    margin-left: -40px;
    top: -40px;
    width: 80px;
    height: 80px;
    border: 3px solid #FFF;
    border-radius: 50%;
  }
  .n2-content{
    font-size:26px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(29,29,29,1);
    line-height:42px;
    text-align: center;
  }

  .n2-time{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(87,87,87,1);
    text-align: center;
  }
  .interflow2{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

.news .Interflow .new2-word{
    width: 220px;
  }
.news .interflow-new2{
    justify-content: space-between;
  }
  .new2-high-num{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(20,20,20,1);
    line-height:24px;
  }

  .new2-fy-all{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(99,99,99,1);
    line-height:24px;
    margin-left: 10px;
  }

  .linkerMsg{
    background-color: #FFF;
    padding: 10px;
  }
  .linkerText{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(155,155,155,1);
    line-height:22px;
  }

  .linkerNum{
    font-size:32px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(182,159,118,1);
  }
.numUnit{
  font-size: 16px;
  font-family:Microsoft YaHei;
  font-weight:bold;
  color:rgba(72,72,72,1);
  margin-left: 8px;
}
  .ask-body{
    padding: 10px;
  }
  .top1-name{
    font-size:16px;
    font-family:Arial;
    font-weight:bold;
    color:rgba(87,87,87,1);
  }
  .top1-spk{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(87,87,87,1);
  }
  .ask-content{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(72,72,72,1);
    line-height:28px;
    margin-top: 16px;
  }
  .ask-time{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(155,155,155,1);
  }
  .askto-body{
    padding: 10px 0;
    background:rgba(244,244,244,1);
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .askto-left img{
    width:60px;
    height:60px;
    border-radius:50%;
    margin-left: 10px;
  }
  .askto-right{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(72,72,72,1);
    line-height:28px;
    margin-left: 10px;
  }
  .ask-bootm-body{
    padding: 0 10px;
  }
  .ask-level-num{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(99,99,99,1);
    line-height:34px;
    border-bottom: 1px solid #E6E5E5;
  }
  .ask-interflow{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
  }
.button {
  color: #15a3f5;
  font-size: 14px;
  width: 62px;
  height: 26px;
  line-height: 26px;
  background: #e8e8e8;
  border-radius: 13px;
  text-align: center;
  cursor: pointer;
}
.button.active {
  color: #fff;
  background: #15a3f5;
}
.button:hover {
  color: #fff;
  background: #15a3f5;
}
  .ask-spkm{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(217,98,160,1);
  }
  .ask-btn-body{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
  }
  .ask-yes{
    width:100px;
    height:38px;
    border:1px solid rgba(21,163,245,1);
    border-radius:8px;
    text-align: center;
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(21,163,245,1);
    line-height:38px;
    cursor: pointer;
  }
  .ask-no{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(196,149,156,1);
    line-height:38px;
    margin-left: 30px;
    cursor: pointer;
  }
  .saishi-body{
    padding: 10px;
  }
  .saishi-jg-top{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .saishi-jg-t-left img{
    width:54px;
    height:54px;
    border-radius:50%;
  }
  .saishi-jg-t-right{
    margin-left: 10px;
  }
  .saishi-name{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(0,0,0,1);
  }
  .saishi-time{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(87,87,87,1);
  }
  .sahi-jg{
    width:148px;
    height:34px;
    background:rgba(219,27,126,1);
    border-radius:8px;
    font-size:18px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(255,255,255,1);
    text-align: center;
    line-height: 34px;
    margin: 0 auto;
  }
  .saishi-content{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:28px;
  }
  .saishi-dw-body{
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 20px;
  }
  .dw-name{
    max-width: 100px;
    /*width:70px;*/
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(72,72,72,1);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-align: center;
  }
  .dw-zx{
    width:24px;
    height:2px;
    background-color: #484848;
  }
  .saishi-dw1-body{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .dw-logo{
    width:56px;
    height:45px;
    margin: 0 20px;
  }
  .shuying-body{
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 20px;
  }
  .ying{
    font-size:32px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(223,202,25,1);
  }
  .shuying-info{
    width:98px;
    height:26px;
    border:1px solid rgba(33,33,33,1);
    border-radius:8px;
    font-size:12px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(72,72,72,1);
    line-height:26px;
    text-align: center;
  }
  .shu{
    font-size:32px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(167,165,150,1);
  }
  .saishi-t-time{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:42px;
    text-align: center;
  }
  .shuying-ss{

  }
  .shuying-info2{
    margin: 0 auto;
  }
  .shuying-body2{
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .ying-body{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .ying2{
    margin-left: 20px;
  }
  .shu2{
    margin-right: 20px;
  }
  .saishi-contents{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:28px;
    padding: 14px;
  }
  .saishi-high-num{
    padding:  0 14px;
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(20,20,20,1);
    line-height:24px;
  }
  .news .message2{
    padding: 0 14px;
  }
.mt12{
  margin-top: 0;
}
.zbq-bt-dj-body{
  position: relative;
}
  .zbq-bt-dj{
    position: absolute;
    height: 100px;
    width: 100%;
    bottom: 0;
    background:linear-gradient(0deg,rgba(255,255,255,0.46),rgba(255,255,255,0));
  }
  .bw-body{
    padding: 14px;
  }
  .bw-title{
    font-size:22px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(0,0,0,1);
    line-height:32px;
  }
  .bw-name{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(87,87,87,1);
  }
  .bw-time{
    font-size:14px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(155,155,155,1);
    margin-left: 10px;
  }
  .bw-content{
    font-size:18px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:29px;
  }
  .bw-de{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(72,141,189,1);
    cursor: pointer;
  }

  .bw-img{
    width:100%;
    height:345px;
    display: block;
  }
  .slelect-linker-body{
    position: fixed;
    right: 0;
    width:0;
    height:100%;
    background:rgba(59,64,68,1);
    overflow-x: hidden;
  }
  .slelect-linker-body2{
    overflow:auto;
    height: 100%;
    width: 390px;
  }
  .sl-list-body{
    width: 320px;
    margin: 0 auto;
  }
  .sl-top-body{
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height:60px;
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color: #FFFFFF;
    height: 60px;
  }
  .sl-sq{
    color:rgba(79,187,42,1);
    cursor: pointer;
  }
  .sl-xt{
    height: 1px;
    background-color: #353739;
  }
  .slke-sq-body{
    position: absolute;width: 100%;right: 0;top: 0;
    background:rgba(59,64,68,1);
    z-index: 1;
  }
  .sl-list{
    display: flex;
    justify-content: flex-start;
    cursor: pointer;
    margin-top: 20px;
  }
  .linker-head{
    width:54px;
    height:54px;
    border-radius:50%;
  }
  .sl-right{
    margin-left: 16px;
  }
  .linker-name{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:bold;
    color:rgba(255,255,255,1);
  }
  .linker-spk{
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(173,173,173,1);
    line-height:22px;
  }
  .link-city{
    margin-top: 8px;
  }
  .jj-big-img{
    width:544px;
    height:341px;
  }
  .ss-body{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ss-yc{
    border:1px solid rgba(226,66,149,1);
    border-radius:8px;
    font-size:12px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(226,66,149,1);
    line-height:34px;
    text-align: center;
    padding: 0 10px;
    margin-right: 14px;
  }
  .v-dw-logo-body{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }
  .zc-b{
    width:27px;
    height:15px;
    font-size:10px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(255,255,255,1);
    line-height:15px;
    text-align: center;
  }
  .vs-v{
    width:50px;
    height:50px;
    border-radius:8px;
    text-align: center;
    line-height: 50px;
  }
  .v-dw-name-bodu{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 200px;
  }
  .dw-sc{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(72,72,72,1);
  }
  .sy-img{
    width: 56px;
    height: 56px;
    position: absolute;
    bottom: -6px;
    left: 50%;
    margin-left: -28px;
    border-radius: 50%;
  }
  .off-on-img{
    width: 50px;
    height: 29px;
    margin-left: 10px;
    cursor: pointer;
  }
  .off-on-body{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #787878;
    font-size: 14px;
    margin-left: 155px;
  }
</style>



// WEBPACK FOOTER //
// src/view/dynamic.vue